export default __webpack_public_path__ + "static/media/search_line_666.f0151043.svg";